import { all } from 'redux-saga/effects';

import atendimentos from './atendimentos/combineSaga';
import processosAdministrativos from './processosAdministrativos/combineSaga';

export default all([atendimentos, processosAdministrativos]);
